// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getWishListLines } from "@insite/client-framework/Services/WishListService";
import { getWishListLinesDataView } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import {
    chain,
    DispatchLoadWishListLines,
    RequestRemoveWishListLine,
    ResetWishListData,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/DeleteWishListLine";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import updateLoadWishListLinesParameter from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateLoadWishListLinesParameter";

export const XLoadWishListLines: typeof RequestRemoveWishListLine = async props => {
    const state = props.getState();
    const parameter = state.pages.myListDetails.loadWishListLinesParameter;
    const productInfosByWishListLineId = state.pages.myListDetails.productInfosByWishListLineId;
    const renderedWishListLinesCount =
        getWishListLinesDataView(state, parameter).value?.filter(
            wishListLine => !!productInfosByWishListLineId[wishListLine.id],
        ).length || 0;

    // if we are in the last page and aim to delete the last item, reload the previous page
    if (renderedWishListLinesCount === 1 && parameter.page && parameter.page > 1) {
        (props as any).apiResult = await getWishListLines({ ...parameter, page: parameter.page - 1 });
        (props as any).forceReload = true;
        props.dispatch(updateLoadWishListLinesParameter({ page: parameter.page - 1 }));
    } else {
        (props as any).apiResult = await getWishListLines(parameter);
    }
};

export const XResetWishListData: typeof ResetWishListData = props => {
    const state = props.getState();
    const parameter = state.pages.myListDetails.loadWishListLinesParameter;
    props.dispatch({
        type: "Data/WishListLines/Reset",
    });

    if ((props as any).forceReload) {
        (props as any).forceReload = false;
        props.dispatch({
            type: "Data/WishLists/Reset",
        });
    }

    props.dispatch({
        type: "Data/WishListLines/CompleteLoadWishListLines",
        parameter,
        result: (props as any).apiResult,
    });
    props.dispatch({
        type: "Data/WishLists/CompleteLoadWishListLines",
        parameter,
        result: (props as any).apiResult,
    });
};

export const XDispatchLoadWishListLines: typeof DispatchLoadWishListLines = props => {
    if (props.parameter.reloadWishListLines) {
        props.dispatch(loadWishListLines({ noDataViewReset: true } as any));
    }
};

addToChainAfter(chain, RequestRemoveWishListLine, XLoadWishListLines);
replaceInChain(chain, ResetWishListData, XResetWishListData);
replaceInChain(chain, DispatchLoadWishListLines, XDispatchLoadWishListLines);
